import LactationChart from "../../_charts/lactation";
import HealthChart from "../../_charts/health";
import FertilityChart from "../../_charts/fertility";
import ActionsChart from "../../_charts/actions";

export default {
  components: { LactationChart, FertilityChart, HealthChart, ActionsChart},
  name: "DashboardChart"
};



// WEBPACK FOOTER //
// ./src/components/_dashboard/chart/dashboard-chart.js